module.exports = require("./crossfilter").crossfilter;



//////////////////
// WEBPACK FOOTER
// ./~/crossfilter/index.js
// module id = 156
// module chunks = 0